<template>
  <div class="min-h-screen bg-gray-50 py-12">
    <div class="container mx-auto px-4 max-w-4xl">
      <h1 class="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600 mb-10 text-center drop-shadow-sm">
        {{ $t('certificates.title') }}
      </h1>
      
      <p class="text-center text-gray-600 mb-12 text-lg">
        {{ $t('certificates.description') }}
      </p>

      <div class="space-y-12">
        <!-- Дата-центр -->
        <div class="bg-white rounded-2xl shadow-xl p-8 hover:shadow-2xl transition-shadow duration-300 border border-gray-100">
          <div class="flex items-center mb-6">
            <div class="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center mr-4">
               <i class="pi pi-server text-blue-600 text-xl"></i>
            </div>
            <h2 class="text-3xl font-bold text-gray-800">{{ $t('certificates.dataCenter.title') }}</h2>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div class="p-6 bg-gradient-to-br from-gray-50 to-white rounded-xl border border-gray-100 hover:border-blue-300 hover:-translate-y-1 transition-transform duration-300">
              <h3 class="text-xl font-bold text-gray-800 mb-2">ISO 9001</h3>
              <p class="text-gray-500 text-sm">{{ $t('certificates.dataCenter.iso9001') }}</p>
            </div>
            <div class="p-6 bg-gradient-to-br from-gray-50 to-white rounded-xl border border-gray-100 hover:border-blue-300 hover:-translate-y-1 transition-transform duration-300">
              <h3 class="text-xl font-bold text-gray-800 mb-2">ISO 27001</h3>
              <p class="text-gray-500 text-sm">{{ $t('certificates.dataCenter.iso27001') }}</p>
            </div>
          </div>
        </div>

        <!-- Security Certifications -->
        <div class="bg-white rounded-2xl shadow-xl p-8 hover:shadow-2xl transition-shadow duration-300 border border-gray-100">
          <div class="flex items-center mb-6">
            <div class="w-12 h-12 rounded-full bg-purple-100 flex items-center justify-center mr-4">
                <i class="pi pi-shield text-purple-600 text-xl"></i>
            </div>
            <h2 class="text-3xl font-bold text-gray-800">{{ $t('certificates.simNetworks.title') }}</h2>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div class="p-6 bg-gradient-to-br from-gray-50 to-white rounded-xl border border-gray-100 hover:border-purple-300 hover:-translate-y-1 transition-transform duration-300">
              <h3 class="text-xl font-bold text-gray-800 mb-2">ISO/IEC 27001</h3>
              <p class="text-gray-500 text-sm">{{ $t('certificates.simNetworks.iso27001') }}</p>
            </div>
            <div class="p-6 bg-gradient-to-br from-gray-50 to-white rounded-xl border border-gray-100 hover:border-purple-300 hover:-translate-y-1 transition-transform duration-300">
              <h3 class="text-xl font-bold text-gray-800 mb-2">PCI DSS V4.0</h3>
              <p class="text-gray-500 text-sm">{{ $t('certificates.simNetworks.pciDss') }}</p>
            </div>
          </div>
        </div>

        <!-- Other Documents -->
        <div class="bg-white rounded-2xl shadow-xl p-8 hover:shadow-2xl transition-shadow duration-300 border border-gray-100">
          <div class="flex items-center mb-6">
            <div class="w-12 h-12 rounded-full bg-teal-100 flex items-center justify-center mr-4">
                <i class="pi pi-file-pdf text-teal-600 text-xl"></i>
            </div>
            <h2 class="text-3xl font-bold text-gray-800">{{ $t('certificates.otherDocuments.title') }}</h2>
          </div>
          <div class="grid grid-cols-1 gap-6">
            <a href="/downloads/Technical_and_organisational_measures.pdf" target="_blank" class="block p-6 bg-gradient-to-br from-gray-50 to-white rounded-xl border border-gray-100 hover:border-teal-300 hover:bg-teal-50 hover:-translate-y-1 transition-all duration-300 group">
              <div class="flex justify-between items-center">
                <div>
                  <h3 class="text-xl font-bold text-gray-800 mb-1 group-hover:text-teal-700 transition-colors">Technical and Organisational Measures</h3>
                  <p class="text-gray-500 text-sm">{{ $t('certificates.otherDocuments.downloadPdf') }}</p>
                </div>
                <i class="pi pi-download text-teal-500 text-2xl group-hover:scale-110 transition-transform"></i>
              </div>
            </a>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n()

useHead({
  title: () => t('certificates.seo.title'),
  meta: [
    { name: 'description', content: () => t('certificates.seo.description') }
  ]
})
</script>
